/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const setMultipleRefs = (...refs) => {
  const filteredRefs = refs.filter(Boolean);
  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 0) return filteredRefs[0];
  return (newRef: React.MutableRefObject<HTMLDivElement>) => {
    filteredRefs.forEach((refToBeUpdated) => {
      if (typeof refToBeUpdated === 'function') {
        refToBeUpdated(newRef);
      } else if (refToBeUpdated) {
        refToBeUpdated.current = newRef;
      }
    });
  };
};
